module.exports = __webpack_public_path__ + "4b3265824307537dc6125d29f23fdbcf.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PR.svg
// module id = A8EE
// module chunks = 0